import { provide, inject, ref, onMounted, nextTick } from "vue";

const KEY = Symbol("formAutofocus");

/**
 * Call in any form screen wrapper component.
 * Automatically focuses the first editable InputField
 * when the screen contains exactly one.
 */
export function provideFormAutofocus() {
  const fields = ref([]);

  provide(KEY, (entry) => fields.value.push(entry));

  onMounted(() => {
    const editable = fields.value.filter((f) => !f.readOnly);
    if (editable.length === 1) {
      nextTick(() => editable[0].focus());
    }
  });
}

/**
 * Called inside InputField to register itself with the nearest FormScreen.
 * Safe to call even when no provider exists (e.g. InputField used standalone).
 */
export function registerFormField(focus, readOnly) {
  const register = inject(KEY, null);
  register?.({ focus, readOnly });
}
